module.exports = __webpack_public_path__ + "media/images/samples/home/top-n-2@2x-3cf8ffb4c1dc22d41349cd94f885f6f0.png";